var map = {
	"./antony-morato.jpg": 3492,
	"./armani-exchange.jpg": 1204,
	"./boggi.jpg": 2246,
	"./boss.jpg": 2123,
	"./calvin-klein-jeans.jpg": 5833,
	"./calvin-klein-underwear.jpg": 5271,
	"./carpisa.jpg": 4809,
	"./dan-john.jpg": 2825,
	"./ea7.jpg": 9547,
	"./gant.jpg": 958,
	"./geox.jpg": 1821,
	"./guess-jeans.jpg": 5931,
	"./guess.jpg": 8713,
	"./hugo.jpg": 9683,
	"./mangoman.jpg": 6526,
	"./plein-sport.jpg": 2600,
	"./replay.jpg": 4905,
	"./springfield.jpg": 839,
	"./stilium.jpg": 1319,
	"./timberland.jpg": 3338,
	"./tom-tailor.jpg": 6488,
	"./tommy-hilfiger.jpg": 1097,
	"./xyz.jpg": 9191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;